import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode };
type State = { error: Error | null; info: ErrorInfo | null };

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null, info: null };

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    this.setState({ error, info });
    console.error("[CPQ] React error boundary:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            padding: "1.5rem",
            fontFamily: "ui-monospace, Consolas, monospace",
            color: "#991b1b",
            background: "#fef2f2",
            minHeight: "100vh",
          }}
        >
          <h1 style={{ color: "#991b1b" }}>CPQ app crashed</h1>
          <p style={{ color: "#374151" }}>
            <strong>{this.state.error.name}:</strong>{" "}
            {this.state.error.message}
          </p>
          <pre
            style={{
              background: "#fff",
              padding: "0.75rem",
              border: "1px solid #fca5a5",
              borderRadius: "4px",
              whiteSpace: "pre-wrap",
              fontSize: "0.78rem",
              maxHeight: "40vh",
              overflow: "auto",
            }}
          >
            {this.state.error.stack}
          </pre>
          {this.state.info && (
            <pre
              style={{
                background: "#fff",
                padding: "0.75rem",
                border: "1px solid #fca5a5",
                borderRadius: "4px",
                whiteSpace: "pre-wrap",
                fontSize: "0.78rem",
                maxHeight: "30vh",
                overflow: "auto",
                marginTop: "0.5rem",
              }}
            >
              {this.state.info.componentStack}
            </pre>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}
